// extracted by mini-css-extract-plugin
module.exports = {"jumboleft":"hero_jumboleft__18gab","askQuestion":"hero_askQuestion__3hLYI","postAnswerButton":"hero_postAnswerButton__Kxvet","iconHovered":"hero_iconHovered__3baBo"};